import React from 'react'
import { Button } from '@mui/material'
import { Box, styled } from '@mui/system'
import { useNavigate } from 'react-router-dom'

const FlexBox = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center'
}))

const JustifyBox = styled(FlexBox)(({ theme }) => ({
	maxWidth: 520,
	flexDirection: 'column',
	justifyContent: 'center',
	[theme.breakpoints.down('md')]: {
		maxWidth: 320
	}
}))

const IMG = styled('img')(() => ({
	width: '100%',
	marginBottom: '32px'
}))

const NotFoundRoot = styled(FlexBox)(() => ({
	width: '100%',
	alignItems: 'center',
	justifyContent: 'center',
	height: '100vh !important'
}))

const NotFound = () => {
	const navigate = useNavigate()

	return (
		<NotFoundRoot>
			<JustifyBox>
				<IMG src='/assets/images/illustrations/page-not-found.svg' alt='' />
				<Button color='primary' variant='contained' onClick={() => navigate('/dashboard')}>
					Navigovať na domov
				</Button>
			</JustifyBox>
		</NotFoundRoot>
	)
}

export default NotFound
